import React from "react";

import { Chip } from "@evidenceb/athena-common/design-system/Chip";
import Avatar from "../../../../components/Avatar/Avatar";
import { defineMessages, useIntl } from "react-intl";
import "./ClusterRow.scss";
import classNames from "classnames";
import { MemberInfo } from "../../utils";
// Interfaces
interface Props {
    member: MemberInfo;
    selectedClusterId?: string;
}
const ClusterRow = ({ member, selectedClusterId }: Props) => {
    const intl = useIntl();
    const isGroup = member.type === "group";
    const isSelectedGroupRow = isGroup && member.id === selectedClusterId;

    return (
        <tr
            key={"cluster-" + member.id}
            className={classNames([
                "cluster-row",
                { "--selected": isSelectedGroupRow },
                { "--is-group": isGroup },
            ])}
        >
            <td>
                {isGroup ? (
                    isSelectedGroupRow ? (
                        <div>{intl.formatMessage(messages.meanGroup)}</div>
                    ) : (
                        <div>{`${intl.formatMessage(messages.group)} ${
                            member.name
                        }`}</div>
                    )
                ) : (
                    <div className={"cluster-row__student"}>
                        <Avatar name={member.name} /> {member.name}
                    </div>
                )}
            </td>
            <td>
                <Chip
                    className="cluster-row__chip"
                    input={member.exerciseResponseTime}
                    colorMode="dark"
                />
            </td>
            <td>
                <Chip
                    className="cluster-row__chip"
                    input={intl
                        .formatMessage(messages.objectives, {
                            count: member.objectivesNbr,
                        })
                        .toLocaleLowerCase()}
                    colorMode="dark"
                />
            </td>
            <td>
                <Chip
                    className="cluster-row__chip"
                    input={member.averageScore}
                    colorMode="dark"
                />
            </td>
        </tr>
    );
};

export default ClusterRow;

const messages = defineMessages({
    meanGroup: {
        id: "dashboard-common-mean-group",
        defaultMessage: "Mean of the group",
    },
    group: {
        id: "dashboard-common-group",
        defaultMessage: "Group",
    },
    objectives: {
        id: "dashboard-cluster-common-objectives",
        defaultMessage:
            "{count, plural, =0 {0 objective} =1 {1 Objective} other {# Objectives}}",
    },
});
